import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, orientation: PropTypes.oneOf(['horizontal', 'vertical']) };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    orientation: 'horizontal',
};

class MoveIcon extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            orientation,
        } = this.props;
        return [
            's-move-icon',
            `s-move-icon--${orientation}`,
            className,
        ];
    }

}

MoveIcon.propTypes = propTypes;

MoveIcon.defaultProps = defaultProps;

export default MoveIcon;
